import(/* webpackMode: "eager" */ "/app/src/assets/svg/iconSideBar-1.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/svg/iconSideBar-2.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/svg/iconSideBar-3.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/svg/iconSideBar-4.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/svg/iconSideBar-5.svg");
;
import(/* webpackMode: "eager", webpackExports: ["FundsPageComponent"] */ "/app/src/components/funds/FundsPageComponent.jsx");
